



















































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { InputeMedicineList } from './DispensationCreateForm.vue'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue'),
    MedicineDetailInputGroup: () => import('./MedicineDetailInputGroup.vue')
  }
})
export default class DispensationCreateForm extends mixins(InputGroup) {
  @Prop(Array) inputMedicines!: InputeMedicineList
  @Prop(Number) rpNo!: number
  @Prop(Boolean) remainingOnlyOneItem!: boolean

  handleChangeIsOnedose(value: boolean) {
    this.inputMedicines.forEach(medicine =>
      this.$set(medicine, 'isOnedose', value)
    )
  }

  handleChangeUsage(value: string) {
    this.inputMedicines.forEach(medicine => this.$set(medicine, 'usage', value))
  }

  handleAddItem(index: number) {
    this.$emit('addMedicineItem', this.rpNo, index)
  }

  handleRemoveItem(index: number) {
    this.$emit('removeMedicineItem', this.rpNo, index)
  }
}
